<script lang="ts">
  import { orgPlus } from "@nrk/origo";
  import { type EditImageActor, updateField } from "./editImageMachine";
  import { type Image, type RightsMarker } from "bildebanken-model";

  export let service: EditImageActor;
  export let image: Image;
  export let usageTermsRequired: boolean;
  export let rightsMarker: RightsMarker;

  $: usageTerms = image.metadata.rights ? image.metadata.rights.note : image.metadata.usageTerms;
  $: invalidUsageTerms = !usageTerms && rightsMarker === "Restricted" && !image.metadata.instructions;

  const suggestions = [
    "Ingen gjenbruk",
    "Kun for redaksjonell omtale",
    "Kan ikke brukes før (dato, tidspunkt)",
    "Bildet er kun ment for bruk i NRK TV eller NRK Radio og kan inneholde ulik grad av bildebehandling / KI. For gjenbruk må rettigheter avklares",
  ];

  function onChangeUsageTerm(suggestionText: string | undefined) {
    const newRights = {
      ...image.metadata.rights,
      note: suggestionText || undefined,
    };
    usageTerms = suggestionText;
    updateField(service, "rights", newRights);
  }

  function onChangeUsageTermInput(this: HTMLInputElement) {
    onChangeUsageTerm(this.value || undefined);
  }
</script>

<div style="margin-top: 1rem">
  <label data-testid="Vilkår" style="position: relative">
    Bruksvilkår
    <span class={usageTermsRequired ? "" : "hidden"}>*</span>
    <textarea
      class="org-input"
      rows="2"
      value={usageTerms || ""}
      on:input={onChangeUsageTermInput}
      aria-invalid={invalidUsageTerms}
      data-testid="rights-usageterms"
      placeholder="Eksempler: Kun til omtale av et tema, sperrefrist med dato."
    />
    <span class="org-warning">Vilkår må fylles ut</span>
  </label>
  <div class="suggest-button">
    {#each suggestions as suggestion}
      <button
        type="button"
        class="org-tag org-tag--suggestive"
        style="margin-top: var(--org-xsmall)"
        on:click={() => onChangeUsageTerm(suggestion)}
      >
        {@html orgPlus}
        <span style="margin-left: 0.25rem" class="org-truncate suggestion-text"
          >Legg til "{suggestion.length > 42 ? suggestion.substring(0, 42) + "..." : suggestion}"
        </span>
      </button>
    {/each}
  </div>
</div>

<style>

  .suggest-button button {
    max-width: 100%;
  }

  .suggestion-text {
    display: inline-flex;
    min-width: 0;
    max-width: calc(100% - 20px);
  }
</style>
